import styled from 'styled-components';

import {
  Text,
} from 'web-styled';

export const Wrapper = styled.div`
  width: 100%;
`;

interface RenderProps {
  isOpen?: boolean
  useCollapse?: boolean
  maxHeight?: number
}

export const Renderer = styled(Text).attrs({
  as: 'div',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}) <RenderProps>`
  position: relative;
  width: 100%;

  ul, ol {
    margin-top: 0
  }

  a {
    color: ${props => props.theme.colors.primary};
  }

  ${props => (props.useCollapse && !props.isOpen) && `
     max-height: ${props.maxHeight}px;
     overflow: hidden;
  `}
`;

export const More = styled.button<{ isOpen: boolean }>`
  color: ${props => props.theme.colors.primary};
  text-align: right;
  width: 100px;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  user-select: none;
  appearance: none;
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: ${props => (props.isOpen ? '-10px' : 0)};
  z-index: 9;
  background: rgb(255,255,255);
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`;
